import MuiDialogActions from '@mui/material/DialogActions';

import { styled } from 'helpers';

import { Props } from './types';

export const DialogActions = styled(MuiDialogActions)<Props>`
  padding: 0 32px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    padding-left: ${({ theme }) => theme.spacing(3)};
    padding-right: ${({ theme }) => theme.spacing(3)};
  }
`;

export default DialogActions;
